/* global gettext */

let anchorLines, anchorBox, sections, mainHeader, newsblogContent, newsblogList

// A flag to prevent multiple executions of the same function simultaneously
let isRunning = false

// Adjusts the position of the anchorLines menu based on the header's state
const setMenuHeight = () => {
    if (window.innerWidth > 991 && anchorLines) {
        const mainHeader = document.querySelector('.main-header')
        const isScrollDown = mainHeader.classList.contains('scroll-down')
        const isScrollUp = mainHeader.classList.contains('scroll-up')
        const currentTop = anchorLines.style.top

        if (isScrollDown && currentTop !== '20px') {
            anchorLines.style.top = '20px'
        } else if (isScrollUp) {
            const newTop = `${mainHeader.offsetHeight + 20}px`
            if (currentTop !== newTop) {
                anchorLines.style.top = newTop
            }
        }
    }
    isRunning = false // Reset the flag after execution
}

// Updates the active link in the anchorLines menu based on the current hash
const updateActiveLink = (hash) => {
    if (hash && anchorLines) {
        anchorLines.querySelectorAll('a').forEach((item) => item.classList.remove('active'))
        const activeLink = anchorLines.querySelector(`a[href="${hash}"]`)
        if (activeLink) activeLink.classList.add('active')
    }
}

// Checks the visibility of sections and highlights the corresponding link
const handleSectionVisibility = () => {
    sections.forEach((section) => {
        const { top, height } = section.getBoundingClientRect()
        const sectionBottom = top + height

        // Highlight link if the section is partially visible within the specified range
        if ((top < 200 && top > 0) || (sectionBottom > 200 && sectionBottom < 300)) {
            anchorLines.querySelectorAll('a').forEach((item) => item.classList.remove('active'))
            const activeLink = anchorLines.querySelector(`a[href="#${section.getAttribute('id')}"]`)
            if (activeLink) activeLink.classList.add('active')
            return
        }

        // Remove highlight if anchor box is off screen
        if (anchorBox.offsetTop - window.scrollY > 200) {
            anchorLines.querySelectorAll('a').forEach((item) => item.classList.remove('active'))

            if (window.innerWidth < 992) {
                anchorLines.classList.add('d-none')
            }
        } else {
            anchorLines.classList.remove('d-none')
        }
    })
}

// Optimizes the execution of setMenuHeight and visibility checks during scroll or resize events
const optimizedSetMenuHeight = () => {
    if (!isRunning) {
        isRunning = true
        requestAnimationFrame(() => {
            setMenuHeight()
            handleSectionVisibility()
        })

        // Checks if the main menu is visible
        if (anchorLines) {
            anchorLines.classList.toggle('anchor-line-top', mainHeader.classList.contains('scroll-down'))
        }
    } else {
        updateActiveLink(window.location.hash)
    }
}

/**
 * Controls adding or removing classes on an element based on click.
 * @param {HTMLElement} element - The element to add/remove the class to.
 * @param {string} add - The name of the class to add/remove.
 */
const menu = (element, add) => {
    const toggleMenu = anchorLines.querySelector('.toggle-menu')
    if (toggleMenu) {
        toggleMenu.addEventListener('click', () => {
            element.classList.toggle(add)
        })
    }
}

const createNewsMenu = () => {
    const sections = document.querySelectorAll('.djangocms-newsblog-article-list section[data-my]')
    const anchorLines = newsblogContent.querySelector('.anchor-lines')

    sections.forEach((section) => {
        const id = section.dataset.my

        // Check if a link with this href already exists
        const exists = anchorLines.querySelector(`a[href="#${id}"]`)

        if (!exists) {
            // Add link to the sticky menu
            anchorLines.insertAdjacentHTML('beforeend', `
                <a href="#${id}" class="">${id.replace(/-/g, ' ')}</a>
            `)

            // Assign the id to the section
            section.id = id
        }
    })
}

const checkNews = () => {
    // Reference to the container news
    newsblogContent = document.querySelector('.djangocms-newsblog-content')
    // Reference to the container element with content for anchor lines
    newsblogList = document.querySelector('.djangocms-newsblog-article-list')

    if (newsblogContent && newsblogList) {

        newsblogList.insertAdjacentHTML('beforebegin', `

        <div class="col col-lg-3 col-12 col-md-12 col-sm-12">
        <div class="anchor-lines"></div>
        </div>
    `)

        newsblogList.classList.add('col', 'col-12', 'col-lg-8', 'anchor-box', 'col-md-12', 'col-sm-12')
        createNewsMenu()
    }

    // Reference to the container element for anchor links in the menu
    anchorLines = document.querySelector('.anchor-lines')
    // Reference to the container element with content for anchor lines
    anchorBox = document.querySelector('.anchor-box')
    // Select all sections with an ID attribute to track their visibility
    sections = document.querySelectorAll('section[id]')
    // Reference to the main menu
    mainHeader = document.querySelector('.main-header')
}

// Initializes the sticky menu and sets up event listeners for scroll and resize
const initMenuSticky = () => {
    checkNews()
    setMenuHeight() // Initial setup
    window.addEventListener('resize', optimizedSetMenuHeight)
    window.addEventListener('scroll', optimizedSetMenuHeight)

    if (anchorLines) {
        if (!anchorLines.querySelector('.anchor-menu-header')) {
            anchorLines.insertAdjacentHTML('afterbegin', `
                <div class="anchor-menu-header">
                    <div><p>${gettext('Overview')}<p></div>
                    <div class="toggle-menu">
                        <img id="anchor-open" class="anchor-menu-icon"
                            src="/../../../static/img/anchor-open.svg"
                                width="24" height="24" alt="☰">
                        <img id="anchor-close" class="anchor-menu-icon"
                            src="/../../../static/img/menu_close.svg"
                            width="16" height="16" alt="x">
                        </div>
                </div>
            `)
        }

        if (window.innerWidth < 992) {
            anchorLines.classList.add('d-none')
        }

        // Close ancherlines after click on link
        anchorLines.querySelectorAll('a').forEach(link =>
            link.addEventListener('click', () => {
                if (anchorLines.classList.contains('show-body')) {
                    anchorLines.classList.remove('show-body')
                }
            }),
        )
        menu(anchorLines, 'show-body')
    }
}

export { initMenuSticky }
